import { combineReducers } from "redux";
import { initialReducer } from "./initialReducer.js";
import { manufacturerCreateReducer } from "./manufacturerCreateReducer";

const rootReducer = combineReducers({
  initialReducer,
  manufacturerCreateReducer,
});
export default rootReducer;
